module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "card page-card-margin"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n      " + _vm._s(_vm.web_texts.sys_info) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "action": "",
      "method": "post"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-1"
  }), _vm._v(" "), _c('label', {
    staticClass: "col-md-2 col-form-label"
  }, [_c('b', [_vm._v(_vm._s(_vm.web_texts.name))])]), _vm._v(" "), _c('label', {
    staticClass: "col-md-2 col-form-label"
  }, [_vm._v(_vm._s(_vm.system.name))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }), _vm._v(" "), _c('label', {
    staticClass: "col-md-3 col-form-label"
  }, [_c('b', [_vm._v(_vm._s(_vm.web_texts.type_invoice))])]), _vm._v(" "), _c('label', {
    staticClass: "col-md-1 col-form-label"
  }, [_vm._v(_vm._s(_vm.system.access_rate))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-1"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('label', {
    staticClass: "col-md-2 col-form-label"
  }, [_vm._v(_vm._s(_vm.system.p1_contracted) + " kW")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('label', {
    staticClass: "col-md-2 col-form-label"
  }, [_vm._v(_vm._s(_vm.system.p2_contracted) + " kW")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('label', {
    staticClass: "col-md-2 col-form-label"
  }, [_vm._v(_vm._s(_vm.system.p3_contracted) + " kW")])]), _vm._v(" "), (_vm.system.p4_contracted !== null) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-1"
  }), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('label', {
    staticClass: "col-md-2 col-form-label"
  }, [_vm._v(_vm._s(_vm.system.p4_contracted) + " kW")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('label', {
    staticClass: "col-md-2 col-form-label"
  }, [_vm._v(_vm._s(_vm.system.p5_contracted) + " kW")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('label', {
    staticClass: "col-md-2 col-form-label"
  }, [_vm._v(_vm._s(_vm.system.p6_contracted) + " kW")])]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n      " + _vm._s(_vm.web_texts.app_info) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "action": "",
      "method": "post"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-1"
  }), _vm._v(" "), _c('label', {
    staticClass: "col-md-2 col-form-label"
  }, [_c('b', [_vm._v(_vm._s(_vm.web_texts.app_version))])]), _vm._v(" "), _c('label', {
    staticClass: "col-md-2 col-form-label"
  }, [_vm._v("v3.8.1")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }), _vm._v(" "), _c('label', {
    staticClass: "col-md-3 col-form-label"
  }, [_c('b', [_vm._v(_vm._s(_vm.web_texts.system_energetic_control))])]), _vm._v(" "), _c('label', {
    staticClass: "col-md-1 col-form-label"
  }, [_vm._v("© 2019")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  })])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-md-1 col-form-label"
  }, [_c('b', [_vm._v("P1")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-md-1 col-form-label"
  }, [_c('b', [_vm._v("P2")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-md-1 col-form-label"
  }, [_c('b', [_vm._v("P3")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-md-1 col-form-label"
  }, [_c('b', [_vm._v("P4")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-md-1 col-form-label"
  }, [_c('b', [_vm._v("P5")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-md-1 col-form-label"
  }, [_c('b', [_vm._v("P6")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-673529a5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/InfoApp.vue
// module id = 552
// module chunks = 1